module.exports = __webpack_public_path__ + "img/p_rear.a35230af.jpg";